import { combine, withContext, withCallback } from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { toaster } from 'utils/toast-wrapper'
import { auth as authRoutes } from 'routes/route.map'

import { INFO_MESSAGE } from './constants'
import ResetPasswordComponent from './component'

export const ResetPassword = combine(
  withContext('auth', StoreContext, ({ auth }) => auth),
  withCallback(
    'onSubmit',
    ({ auth }, { history }) =>
      async ({ email }) => {
        // Set skipErrorToaster flag to prevent global error handler from showing error messages
        await auth
          .resetPassword(email, { skipErrorToaster: true })
          .catch(() => undefined)
        toaster.info(INFO_MESSAGE)
        history.push(authRoutes.login())
      },
    []
  )
)(ResetPasswordComponent)
